export const TAB_CONTENT_PT_BR = {
	consolidated: "Competência",
	extract: "Extrato",
	revenueSettlement: "Apuração de Caixa",
	pendingTransactions: "Transações Pendentes",
	new: "NOVO",
	consolidatedTooltip:
		"Indica o período em que a venda ou operação foi realizada, independentemente da data de pagamento.",
	revenueSettlementTooltip:
		"Indica o período em que os valores foram efetivamente pagos ou recebidos.",
	pendingTransactionsTooltip:
		"Relação de transações em avaliação pelo time Zig, ainda não contabilizadas no extrato.",
};

export type TabContentTranslations = typeof TAB_CONTENT_PT_BR;
